import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'highlighter'
})
export class HighlighterPipe implements PipeTransform {

    transform(value: any, args: any): unknown {
        if (!args) {
            return value;
        }
        const re = new RegExp(this.checkArgs(args.trim()), 'igm');
        if (value === null) {
            return value;
        }
        value = value.replace(re, '<mark>$&</mark>');
        return value;
    }

    private checkArgs(args: any): string {
        if (args === '.' || args === '+' || args === '*' || args === '?' || args === '$' || args === '(' || args === ')'
            || args === '{' || args === '}' || args === '[' || args === ']' || args === '|' || args === '\\') {
            return '\\' + args;
        }
        return args;
    }
}
